import { springApiClient } from '@/api/spring-boot-client';
import type { PaymentGatewayConfig, UpsertPaymentGatewayRequest } from '@/types';

export const paymentGatewayService = {
  getPaymentGatewayConfig: async (): Promise<PaymentGatewayConfig | null> => {
    try {
      const response = await springApiClient.get<PaymentGatewayConfig>('/payment-gateway');
      return response;
    } catch (error) {
      // 404 means not configured yet
      if (error && typeof error === 'object' && 'status' in error && error.status === 404) {
        return null;
      }
      throw error;
    }
  },

  upsertPaymentGatewayConfig: async (request: UpsertPaymentGatewayRequest): Promise<PaymentGatewayConfig> => {
    const response = await springApiClient.put<PaymentGatewayConfig>('/payment-gateway', request);
    return response;
  },
};
